(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["popup-morphzine"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    if (!(sessionStorage.getItem("hide_popup_morphzine") == "yes")) {
      document.querySelector(".popup-morphzine").classList.remove("popup-morphzine--hidden")
    }

    document.querySelectorAll(".popup-morphzine__inventory_count").forEach(el => {
      el.innerText = el.dataset.count.padStart(3, "0")
    })
  })

  document.querySelector(".popup-morphzine__close").addEventListener("click", () => {
    document.querySelector("#shopify-section-popup-morphzine").remove()
    sessionStorage.setItem("hide_popup_morphzine", "yes")
  })
  document.querySelector(".popup-morphzine__row").addEventListener("click", () => {
    document.querySelector("#shopify-section-popup-morphzine").remove()
    sessionStorage.setItem("hide_popup_morphzine", "yes")
  })

  } catch(e) { console.error(e); }
})();
})();
